import * as ActionTypes from "../../Actions/DriverLog/ActionTypes"
import {
    GET_DRIVER_CHANGE_COORDINATELOGS, GET_DRIVER_CHANGE_COORDINATELOGS_FAIL,
    GET_DRIVER_CHANGE_COORDINATELOGS_SUCCESS
} from "../../Actions/DriverLog/ActionTypes";

export const getDriverLogAction = (data) => {
    return {type: ActionTypes.GET_DRIVER_LOG, data};
};
export const getDriverLogSuccessAction = (res) => {
    return {type: ActionTypes.GET_DRIVER_LOG_SUCCESS, res};
};
export const getDriverLogFailAction = (error) => {
    return {type: ActionTypes.GET_DRIVER_LOG_FAIL, error};
};


export const getDriverChangeCorrdinateAction = (data) => {
    return {type: ActionTypes.GET_DRIVER_CHANGE_COORDINATE_LOGS, data};
};
export const getDriverChangeCorrdinateSuccessAction = (res) => {
    return {type: ActionTypes.GET_DRIVER_CHANGE_COORDINATE_LOGS_SUCCESS, res};
};
export const getDriverChangeCorrdinateFailAction = (error) => {
    return {type: ActionTypes.GET_DRIVER_CHANGE_COORDINATE_LOGS_FAIL, error};
};




export const updateChangeLocationStatusAction = (data) => {
    return {type: ActionTypes.UPDATE_CHANGE_LOCATION_STATUS, data};
};
export const updateChangeLocationStatusSuccessAction = (res) => {
    return {type: ActionTypes.UPDATE_CHANGE_LOCATION_STATUS_SUCCESS, res};
};
export const updateChangeLocationStatusFailAction = (error) => {
    return {type: ActionTypes.UPDATE_CHANGE_LOCATION_STATUS_FAIL, error};
};

export const getPlanChangeStatusesExcelAction = () => {
    return {type: ActionTypes.GET_PLAN_CHANGE_STATUSES_EXCEL};
};
export const getPlanChangeStatusesExcelSuccessAction = (res) => {
    return {type: ActionTypes.GET_PLAN_CHANGE_STATUSES_EXCEL_SUCCESS, res};
};
export const getPlanChangeStatusesExcelFailAction = (error) => {
    return {type: ActionTypes.GET_PLAN_CHANGE_STATUSES_EXCEL_FAIL, error};
};
export const clearPlanChangeStatusesExcelAction = () => {
    return {type: ActionTypes.CLEAR_PLAN_CHANGE_STATUSES_EXCEL};
};